export default __webpack_public_path__ + "static/data_revolt-dbf5361a067b1a6a38938294e3233d7b.svg";